import Sentry from "lib/sentry/init";
import { UploadedImageResponse } from "./UploadedImageResponse";
import { uploadMedia } from "lib/cloudinary/uploadMedia";

export const handleUploadImage = async (
  file: File
): Promise<UploadedImageResponse | null> => {
  try {
    return await uploadMedia(file, "image");
  } catch {
    Sentry.captureException("Could not upload image!");
    return null;
  }
};
